import { yupResolver } from '@hookform/resolvers/yup';

import yup, { ErrorLengthMax, ErrorLengthMin, ERROR_REQUIRED } from 'utils/yup-form-validator';

const schema = yup.object({
  username: yup.string().min(3, ErrorLengthMin(3)).max(48, ErrorLengthMax(48))
    .required(ERROR_REQUIRED),
  password: yup.mixed()
    .test({
      name: 'password',
      message: 'Must contain at least 8 characters',
      test: (value: string) => !(value.length > 0 && value.length < 8),
    }),
  confirmPassword: yup.string()
    .when('password', {
      is: (password: string) => password.length > 0,
      then: yup.string().passwordIdentical('password').required(),
    }),
});

const validator = yupResolver(schema);

export default validator;
